import { replaceState } from '$app/navigation';
import { get } from 'svelte/store';
import { page } from '$app/stores';
import cookie from 'cookie';

/**
 * @param {string} href
 * @param {boolean} showMap
 */
export default function toggleMap(href, showMap) {
  const url = new URL(href);

  if (showMap) {
    url.searchParams.delete('show_map');
  } else {
    url.searchParams.set('show_map', 'true');
  }

  replaceState(url.href, { ...get(page).state, exploreMapIsVisible: url.searchParams.has('show_map') });

  document.cookie = cookie.serialize('exploreHref', url.href, {
    domain: url.hostname,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    maxAge: 60 * 60 * 24 * 365,
    sameSite: 'strict',
  });
}
